import {Pipe, PipeTransform} from '@angular/core';
import {TimeSpan} from "../models/TimeSpan";

@Pipe({
  name: 'timeSpan'
})
export class TimeSpanPipe implements PipeTransform {
  transform(value: TimeSpan | string | number, format: 'c' | 'd' = 'c'): string {
    if (value == null) return ''

    if (typeof value === 'string') {
      value = TimeSpan.getTimeSpanFromString(value);
    }

    if (typeof value === 'number') {
      value = new TimeSpan(value);
    }

    if (format === 'c') {
      return value.toString();
    }
    if (format == 'd') {
      // 0d:18h:12m:38s.0000000ms
      return value.toString({addDays: true, symbols: true, addHours: true, addMinutes: true, addSeconds: true, addMilliseconds: true, addDaysOnlyIfValue: false});
    }

    return value.toString();
  }
}
